import React, { useEffect } from 'react';
import { domain } from '../../../utils/variables';
import { useOfficialDomain } from '../../../hooks';
import { createRelativeUrl } from '../../../utils/functions';

let lastAlpha2 = null;
const DomainChecker = () => {
  const { isUnofficialDomainAllowed, siteWide, officialDomain, allowedDomains, alpha2 } =
    useOfficialDomain();
  useEffect(() => {
    setTimeout(function () {
      if (
        alpha2 &&
        lastAlpha2 !== alpha2 &&
        siteWide &&
        officialDomain &&
        window.location.href.indexOf(officialDomain) < 0 &&
        window.location.href.indexOf('localhost') < 0 &&
        (domain?.env === 'production' || domain?.env === 'staging')
      ) {
        lastAlpha2 = alpha2;
        if (allowedDomains && isUnofficialDomainAllowed) {
          // don't redirect
        } else if (window.location.pathname === '/')
          window.location.href = officialDomain;
        else {
          const params = new URLSearchParams(window.location.search);
          const newPath = createRelativeUrl({
            path: officialDomain + window.location.pathname,
            queryObject: { ...params, c: alpha2 },
          });
          window.location.href = newPath;
        }
      }
    }, 300);
  }, [alpha2]);

  return <></>;
};

export default DomainChecker;
